import { render, staticRenderFns } from "./PublishButton.vue?vue&type=template&id=23aeed39&"
import script from "./PublishButton.vue?vue&type=script&lang=js&"
export * from "./PublishButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports